import React from 'react';
import { useTranslation } from 'react-i18next';
import { SUPPORTED } from '../i18n';
import './LanguageSwitcher.css';

/**
 * Renders EN | RO (or current language highlighted). Used in sidebar/header.
 */
export default function LanguageSwitcher() {
  const { i18n } = useTranslation();

  return (
    <div className="language-switcher" role="group" aria-label="Language">
      {SUPPORTED.map((lng) => (
        <button
          key={lng}
          type="button"
          className={`language-switcher-btn ${i18n.language === lng ? 'active' : ''}`}
          onClick={() => i18n.changeLanguage(lng)}
          lang={lng}
          title={lng === 'en' ? 'English' : lng === 'ro' ? 'Română' : lng}
        >
          {lng.toUpperCase()}
        </button>
      ))}
    </div>
  );
}
